import { type UseQueryResult } from '@tanstack/react-query';
import { createNamedContext } from '@trinity/chat-components/utils';

type RateLimiting = {
  allowed: boolean;
  limit: number | null;
  current: number;
};

export type RateLimitingContextValue = {
  query: UseQueryResult<RateLimiting> | null;
};

export const RateLimitingContext = createNamedContext<RateLimitingContextValue>({ query: null }, 'RateLimiting.Context');